// 그룹 헤더 탭 훅 — menus.js GROUP_TABS[groupId] 를 HeaderLeft 에 그리고 클릭 시 navigate('/main/<id>').
// 사용: var tabs = useGroupTabs('cars', 'car-list');  → JSX 트리 어딘가에 {tabs} 를 둔다.
// 차량(목록·등록·말소 진행·보강서류) / 세무·장부(세무처리·세금계산서·장부) 4+4 화면이 호출한다.
// 상시 마운트 화면(car-register / eval, Routes 밖 display:none) 이 남의 헤더에 탭을 꽂지 않도록
// 현재 URL 이 '/main/<activeId>' 일 때만 그린다.
// 배지: Dashboard.js 가 V2BadgeContext 로 { cancelDocCount, role } 를 내려준다 (GROUP_TABS 의 badgeKey 로 조회).
// 역할: GROUP_TABS 항목에 roles 가 있으면 role 이 그 안에 있을 때만 그린다(말소 정산 = 업체 사용자만).
import React, { createContext, useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { GROUP_TABS } from '../menus';
import { useIsMobile } from '../../utils/useMobile';
import HeaderLeft from './HeaderLeft';
import HeaderTabs from './HeaderTabs';

export var V2BadgeContext = createContext({});

function useGroupTabs(groupId, activeId) {
  var navigate = useNavigate();
  var loc = useLocation();
  var isMobile = useIsMobile();
  var badges = useContext(V2BadgeContext) || {};
  var here = String(loc.pathname || '').replace(/\/+$/, '') === '/main/' + activeId;
  var defs = (GROUP_TABS[groupId] || []).filter(function (t) { return !t.roles || t.roles.indexOf(badges.role) >= 0; });
  if (!here || !defs.length) return null;
  var items = defs.map(function (t) {
    return { id: t.id, label: t.label, on: t.id === activeId, badge: t.badgeKey ? (badges[t.badgeKey] || 0) : 0,
      onClick: function () { if (t.id !== activeId) navigate('/main/' + t.id); } };
  });
  return (<HeaderLeft><HeaderTabs items={items} isMobile={isMobile} /></HeaderLeft>);
}

export default useGroupTabs;
